
import React, { useEffect, useState } from 'react'
import IApiResponse from '../types/IApiResponse';
import { fetchData } from '../services/api';
import apiUrls from '../config/apiUrls';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useLoading } from '../contexts/LoadingContext';
import handleApiResponse from '../utils/handleApiResponse';
import MFLoginLogo from "../assets/images/MF_logo.png";
import LabelText from '../ui/LabelText';

const GrantAccessPage = () => {
    const navigate = useNavigate();
      const { startLoading, stopLoading, loading } = useLoading();
      const [grantAccess, setIsGrantAccess] = useState<boolean>(false);
      const [errorMsg, setErrorMsg] = useState<string>(""); // ✅ Correct state
    
      const testParams = window.location.search;
      const urlParams = new URLSearchParams(window.location.search);
      useEffect(() => {
        const GrantAccess = async () => {
          startLoading();
          try {
            const response: IApiResponse<any> = await fetchData(
              `${apiUrls["GrantAccess"]}${testParams}`
            );
            handleApiResponse(
              response,
              (responseData) => {
                stopLoading();
                if (response.isSuccess) {
                    setIsGrantAccess(true);
                } else {
                    setIsGrantAccess(false);
                  // setErrorMsg(responseData.error?.message || 'Verification failed.');
                }
              },
              (error) => {
                stopLoading();
                setErrorMsg(response.error?.message);
              }
            );
          } catch (error) {
            stopLoading();
            console.error("Error during account approval:", error);
            // setErrorMsg('Something went wrong while verifying the email.');
          }
        };
        if(testParams){
          GrantAccess();
        }
      }, [testParams]);
  return (
    <>
    <div className="login-wrapper">
        <div className="login-container" style={{ padding: "30px", alignItems: "stretch", width: "500px" }}>
          <div className="logo center">
            <img src={MFLoginLogo} alt="mc-football-logo" />
          </div>
          <div className="signup-success-conatiner">
            {grantAccess ? (
              <>
                <LabelText
                  className="player-family-name"
                  style={{ color: "#54E0C5", textAlign:'center' }}
                >
                  Account Approved Successfully
                </LabelText>
                <LabelText>
                  You have approved the new user with the email address : <b style={{color: "#54E0C5"}}>{urlParams.get("email") ?? ""}</b>.
                </LabelText>
                <LabelText>
                 The user can now log in and start using the application.
                </LabelText>
                {/* <LabelText>
                  Please{" "}
                  <a
                    style={{ textDecoration: "underline", color: "black" }}
                    onClick={() => navigate("/login")}
                  >
                    Log in
                  </a>{" "}
                  to access your account.
                </LabelText>
                <PrimaryButton
                  className="login-button"
                  label="Log in"
                  onClick={() => navigate("/login")}
                /> */}
              </>
           ) : errorMsg ? (
            <LabelText className="error-text" style={{ color: "red" }}>
              {errorMsg}
            </LabelText>
          ) : (
            !testParams && (
              <LabelText className="error-text" style={{ color: "red" }}>
                Some error occurred. Please try again later!
              </LabelText>
            )
          )}

          </div>
        </div>
    </div>
    </>
  )
}

export default GrantAccessPage